/* Relatório para impressora térmica 80mm */

export default function ThermalReport({ titulo, periodo, escopo, metricas, vendas, mode = "completo", hideProfitCost = false }) {
  const money = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;
  const dt = new Date();
  const totals = {
    bruto: vendas.reduce((s, v) => s + v.total_bruto, 0),
    desconto: vendas.reduce((s, v) => s + v.total_desconto, 0),
    liquido: vendas.reduce((s, v) => s + v.total_liquido, 0),
    cmv: vendas.reduce((s, v) => s + v.total_custo_cmv, 0),
    lucro: vendas.reduce((s, v) => s + v.lucro, 0),
    itens: vendas.reduce(
      (s, v) => s + (v.itens?.reduce((a, i) => a + i.quantidade, 0) || 0),
      0
    ),
  };

  return (
    <div id="thermal-receipt" className="thermal-receipt mx-auto border border-neutral-300">
      <div className="text-center">
        <div className="font-bold text-sm uppercase">{titulo}</div>
        <div className="text-[10px]">Gerado em {dt.toLocaleString("pt-BR")}</div>
      </div>
      <hr />
      <div className="text-[11px]">
        {escopo && <div>ESCOPO: {escopo}</div>}
        {periodo && <div>PERÍODO: {periodo}</div>}
      </div>
      {metricas && metricas.length > 0 && (
        <>
          <hr />
          <div className="text-[11px]">
            <div className="font-bold">RESUMO</div>
            {metricas.map((m, i) => (
              <div key={i} className="flex justify-between">
                <span>{m.label}</span>
                <span className="font-bold">{m.value}</span>
              </div>
            ))}
          </div>
        </>
      )}
      <hr />
      <div className="text-[11px]">
        <div className="font-bold">VENDAS ({vendas.length}){mode === "resumido" && " · RESUMO"}</div>
        {vendas.length === 0 && (
          <div className="text-center mt-2">Sem vendas no período</div>
        )}
        {mode === "completo" && vendas.map((v, idx) => (
          <div key={v.id} className="mt-2 border-t border-dashed border-black pt-1">
            <div className="flex justify-between">
              <span>#{String(idx + 1).padStart(3, "0")}</span>
              <span>{new Date(v.data_venda).toLocaleDateString("pt-BR")} {new Date(v.data_venda).toLocaleTimeString("pt-BR", {hour:"2-digit",minute:"2-digit"})}</span>
            </div>
            <div>VEND: {v.vendedor_nome}</div>
            {v.cliente_nome && <div>CLI: {v.cliente_nome}</div>}
            {v.placa && <div>PLACA: {v.placa}</div>}
            {v.itens?.map((it, i) => (
              <div key={i} className="pl-2">
                - {it.quantidade}x {it.nome} {money(it.subtotal)}
              </div>
            ))}
            <div className="flex justify-between font-bold">
              <span>TOTAL</span>
              <span>{money(v.total_liquido)}</span>
            </div>
          </div>
        ))}
      </div>
      <hr />
      {vendas.length > 0 && (
        <div className="text-[11px]">
          <div className="flex justify-between">
            <span>QTD ITENS</span>
            <span className="font-bold">{totals.itens}</span>
          </div>
          <div className="flex justify-between font-bold">
            <span>FAT. BRUTO</span>
            <span>{money(totals.bruto)}</span>
          </div>
          <div className="flex justify-between">
            <span>DESCONTOS</span>
            <span>- {money(totals.desconto)}</span>
          </div>
          <div className="flex justify-between font-bold">
            <span>FAT. LÍQUIDO</span>
            <span>{money(totals.liquido)}</span>
          </div>
          {!hideProfitCost && (
            <>
              <div className="flex justify-between">
                <span>CMV</span>
                <span>{money(totals.cmv)}</span>
              </div>
              <div className="flex justify-between font-bold">
                <span>LUCRO</span>
                <span>{money(totals.lucro)}</span>
              </div>
            </>
          )}
        </div>
      )}
      <div className="text-center text-[10px] mt-3">--- FIM DO RELATÓRIO ---</div>
    </div>
  );
}
